/*
 * @Author: Jsonzhang0215
 * @Date:   2018-03-31 10:58:17
 * @Last Modified by: Jason
 * @Last Modified time: 2018-05-06 20:27:20
 */
import axios from '@/lib/axios'
// const defaultHead = require('@/assets/defaultHead.png')
// const defaultCard = require('@/assets/defaultCard.png')
const user = {
    state: {
        showHead: true,
        name: '', // 用户名
        favicon: '', // 头像
        branchId: '', // 所在党支部ID
        branchName: '', // 党支部名称
        deptId: '', // 所在党委/党总支ID
        deptName: '', // 所在党委/党总支名称
        rangeList: [], // 子系统列表
        realName: '', // 真实姓名
        parent_full_name: '', // 父组织名称
        full_name: '', // 本组织名称
        parent_short_name: '', // 父组织简称
        short_name: '', // 组织简称
        uid: '', // 人id
        mobile_verified: '', // 手机号是否验证
        // 当前管理节点
        range: {
            rangeId: '', // 管理的最高节点ID
            rangeName: '', // 管理最高节点对应的名称
            rangeType: '' // 管理最高节点对应的党组织类型
        },
        mobile: '', // 手机号
        offical_photo_url: '', // 证件照
        specialcCode: [], // 特殊编码 特殊权限menu_id: '',
        // 积分数据
        creditData: {
            credit: '',
            credit_limit: ''
        },
        // 学习 答题统计
        studyData: {
            study_time_i: '',
            today_percent: '',
            today_times: ''
        },
        // 入党天数
        party_days: '',
        // 登录人数
        loginData: {
            checkin_pm: '',
            checkin_total: '',
            login_total: '',
            user_pm: ''
        },
        checkData: {
            keep_time: '',
            today_checked: ''
        }
    },
    getters: {
    },
    mutations: {
        setUserInfo (state, info) {
            // console.log('Mutation: setUserInfo');
            state.name = info.user_name;
            state.real_name = info.real_name;
            state.favicon = (info.favicon === '' ? '' : info.favicon);
            state.branchId = info.branch_id;
            state.mobile_verified = String(info.mobile_verified)
            state.branchName = info.branch_name;
            state.deptId = info.dept_id;
            state.deptName = info.full_name;
            state.rangeId = info.range_id;
            state.rangeName = info.range_name;
            state.rangeType = info.range_type;
            state.parent_full_name = info.parent_full_name
            state.full_name = info.full_name
            state.parent_short_name = info.parent_short_name
            state.short_name = info.short_name
            state.uid = info.uid;
            state.parent_short_name = info.parent_short_name
            if (info.current_range) {
                state.range = {
                    rangeId: info.current_range.dept_id,
                    rangeName: info.current_range.full_name,
                    rangeType: info.current_range.dept_type
                }
                state.current_range = info.current_range;
            }
            state.rangeList = info.range_arr;
            state.specialcCode = info.special_code;
            state.sub_system_id = info.sub_system_id;
            state.offical_photo_url = (info.offical_photo_url === '' ? '' : info.offical_photo_url);
            state.mobile = info.mobile;
        },
        // 入党天数
        setPartyDays (state, paload) {
            state.party_days = paload.party_days
        }
    },
    actions: {
        getUserInfo (store) {
            return new Promise((resolve, reject) => {
                axios.get('/ucenter/login/webuserinfo')
                    .then(res => {
                        let data = res.data;
                        if (data.code === 200) {
                            store.commit('setUserInfo', data.data);
                            resolve();
                        } else {
                            reject(new Error('Login error'))
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        reject(err);
                    });
            })
        }
    }
}

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js